export type EnvVariables = {
  stateInMemory: boolean;
  enableIxExtension: boolean;
};

const devVariables: EnvVariables = {
  stateInMemory: true,
  enableIxExtension: true,
};
const prodVariables: EnvVariables = {
  stateInMemory: false,
  enableIxExtension: true,
};

export const envVariables =
  typeof window !== "undefined" && window.location.hostname === "localhost"
    ? devVariables
    : prodVariables;
